import React, {useEffect} from 'react';
import classes from './PlatformNav.module.css';
import NavItem from "./NavItem";
import HorizontalDivider from "../../../../components/Divider/HorizontalDivider";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {
    BookOutlined,
    ContainerOutlined,
    EditFilled,
    FileDoneOutlined,
    FileTextOutlined,
    HomeOutlined,
    LogoutOutlined,
    ProfileOutlined,
    ReadOutlined,
    SettingOutlined,
    ShopOutlined,
    TeamOutlined,
    UnorderedListOutlined,
    UserOutlined
} from "@ant-design/icons";
import LogoBlack from "../../../components/Logo/LogoBlack";
import {Badge, Flex} from "antd";
import {
    countUnsignedCertificates,
    countUnsignedForms,
    countUserSignsDirector
} from "../../../../store/slices/CounterSlice";

const NavMenu = () => {
    const {user} = useSelector(state => state.user);

    return (
        <div className={classes.menu}>
            {/*<NavLan/>*/}
            {/*<BrainBrewText/>*/}
            <Flex style={{width: "100%", paddingTop: 20}} align={"center"} justify={"center"}>
                <LogoBlack/>
            </Flex>

            <div style={{paddingBottom: 25}}></div>
            <HorizontalDivider/>
            <RoleNav/>
            <HorizontalDivider/>
            {
                user &&
                <NavItem to={'logout'} icon={<LogoutOutlined/>} text={<IntlMessage id={'logout'}/>}/>
            }
        </div>
    );
};

const RoleNav = () => {
    const {user} = useSelector(state => state.user);
    const {
        unsignedCertsCount,
        unsignedFormsCount,
        unsignedUserSignsDirectorCount,
        isLoading
    } = useSelector(state => state.counterDocs);
    const dispatch = useDispatch();

    useEffect(() => {
        // Очередь одна на обе роли, поэтому и счётчики директорские: у проректорских
        // условия отбора остались старыми и разошлись бы с объединёнными списками.
        if (user?.role.roleName === 'director' || user?.role.roleName === 'rector') {
            dispatch(countUnsignedForms({type: 'director'}));
            dispatch(countUserSignsDirector());
            dispatch(countUnsignedCertificates());
        }
    }, [dispatch, user?.role.roleName]);

    if (user?.role.roleName === 'admin') {
        return (
            <>
                {/*<NavItem to={'profile'} icon={<UserOutlined />} text={<IntlMessage id={'profile'}/>}/>*/}
                <NavItem to={'applications'} loc={'/p/applications'} icon={<FileTextOutlined/>}
                         text={<IntlMessage id={'applications'}/>}/>
                <NavItem to={'courses'} loc={'/p/courses'} icon={<ReadOutlined/>} text={<IntlMessage id={'courses'}/>}/>
                <NavItem to={'contracts'} loc={'/p/contracts'} icon={<EditFilled/>}
                         text={<IntlMessage id={'contracts'}/>}/>
                <NavItem to={'globalData'} loc={'/p/globalData'} icon={<ProfileOutlined/>}
                         text={<IntlMessage id={'globalData'}/>}/>
                {/*<NavItem to={'teachers'} loc={'/p/teachers'} icon={<UserOutlined />} text={<IntlMessage id={'teachers'}/>}/>*/}
                <NavItem to={'orders'} loc={'/p/orders'} icon={<UserOutlined/>} text={<IntlMessage id={'orders'}/>}/>
                <NavItem to={'users'} loc={'/p/users'} icon={<UserOutlined/>} text={<IntlMessage id={'users'}/>}/>
                <NavItem to={'groups'} loc={'/p/groups'} icon={<TeamOutlined/>}
                         text={<IntlMessage id={'ordersPage.groups'}/>}/>
                <NavItem to={'acw'} loc={'/p/acw'} icon={<FileDoneOutlined/>} text={<IntlMessage id={'acw.short'}/>}/>
                <NavItem to={'user-sign'} loc={'/p/user-sign'} icon={<FileTextOutlined/>}
                         text={<IntlMessage id={'userSignPage'}/>}/>
                <NavItem to={'certificates'} loc={'/p/certificates'} icon={<BookOutlined/>}
                         text={<IntlMessage id={'certificates'}/>}/>
                <NavItem to={'aituexceltest'} loc={'/p/aituexceltest'} icon={<UnorderedListOutlined/>}
                         text={<IntlMessage id={'aituExcelTest'}/>}/>
                <NavItem to={'microqualification'} loc={'/p/microqualification'} icon={<ContainerOutlined/>}
                         text={<IntlMessage id={'microQualification'}/>}/>
                <NavItem to={'microqualification-groups'} loc={'/p/microqualification-groups'} icon={<TeamOutlined/>}
                         text={<IntlMessage id={'mqGroups'}/>}/>
                <NavItem to={'market-courses'} loc={'/p/market-courses'} icon={<ShopOutlined/>}
                         text={<IntlMessage id={'marketCoursesPage.nav'}/>}/>
                {/*<NavItem to={'downloaded-files'} loc={'/p/downloaded-files'} icon={<VerticalAlignTopOutlined />} text={<IntlMessage id={'files'}/>}/>*/}
            </>
        )
    }

    if (user?.role.roleName === 'director' || user?.role.roleName === 'rector') {
        return (
            <>
                {/* Подписывает директор, и делает это одной кнопкой: отдельного пункта
                    «Документы на подписание» для проректора больше нет — очередь одна.
                    Счётчики тоже директорские: их условия совпадают с объединёнными списками. */}
                <NavItem to={'user-sign'} loc={'/p/user-sign'} icon={<FileTextOutlined/>} text={
                    <span style={{display: 'flex', alignItems: 'center', gap: 6}}>
                        <IntlMessage id={'userSignPage'}/>
                        <Badge
                            count={unsignedUserSignsDirectorCount}
                            overflowCount={99}
                            offset={[-20, -20]}
                        />
                    </span>
                }/>
                <NavItem to={'applications'} loc={'/p/applications'} icon={<FileTextOutlined/>} text={
                    <span style={{display: 'flex', alignItems: 'center', gap: 6}}><IntlMessage
                        id={'applications'}/><Badge
                        count={unsignedFormsCount} overflowCount={99}
                        offset={[0, -20]}/>
                    </span>}/>
                <NavItem to={'contracts'} loc={'/p/contracts'} icon={<EditFilled/>}
                         text={<IntlMessage id={'contracts'}/>}/>
                {/* Сертификаты подписывает тот же ЭЦП-ключ директора, поэтому пункт
                    показываем обеим ролям, а не только проректору. */}
                <NavItem to={'unsigned-certificates'} loc={'/p/unsigned-certificates'} icon={<BookOutlined/>}
                         text={<span style={{display: 'flex', alignItems: 'center', gap: 6}}><IntlMessage
                             id="certificatesForSign"/><Badge count={unsignedCertsCount} overflowCount={99}
                                                              offset={[-20, -20]}/></span>}/>
                <NavItem to={'microqualification'} loc={'/p/microqualification'} icon={<ContainerOutlined/>}
                         text={<IntlMessage id={'microQualification'}/>}/>
                <NavItem to={'certificates'} loc={'/p/certificates'} icon={<BookOutlined/>}
                         text={<IntlMessage id={'certificates'}/>}/>
            </>
        )
    }

    if (user?.role.roleName === 'mEditor') {
        return (
            <>
                <NavItem to={'microqualification'} loc={'/p/microqualification'} icon={<ContainerOutlined/>}
                         text={<IntlMessage id={'microQualification'}/>}/>
                <NavItem to={'market-courses'} loc={'/p/market-courses'} icon={<ShopOutlined/>}
                         text={<IntlMessage id={'marketCoursesPage.nav'}/>}/>
                <NavItem to={'settings'} loc={'/p/settings'} icon={<SettingOutlined/>}
                         text={<IntlMessage id={'settings'}/>}/>
            </>
        )
    }

    if (user?.role.roleName === 'teacher') {
        return (
            <>
                <NavItem to={'home'} loc={'/p/home'} icon={<HomeOutlined/>}
                         text={<IntlMessage id={'personalCabinet'}/>}/>
                <NavItem to={'groups'} loc={'/p/groups'} icon={<TeamOutlined/>}
                         text={<IntlMessage id={'ordersPage.groups'}/>}/>
                <NavItem to={'settings'} loc={'/p/settings'} icon={<SettingOutlined/>}
                         text={<IntlMessage id={'settings'}/>}/>
            </>
        )
    }

    if (user?.role.roleName === 'student') {
        return (
            <>
                <NavItem to={'home'} loc={'/p/home'} icon={<HomeOutlined/>}
                         text={<IntlMessage id={'personalCabinet'}/>}/>
                <NavItem to={'user-sign'} loc={'/p/user-sign'} icon={<FileTextOutlined/>}
                         text={<IntlMessage id={'userSignPage'}/>}/>
                {/*<NavItem to={'contracts'} loc={'/p/contracts'} icon={<EditFilled />} text={<IntlMessage id={'contracts'}/>}/>*/}
                <NavItem to={'groups'} loc={'/p/groups'} icon={<TeamOutlined/>}
                         text={<IntlMessage id={'ordersPage.groups'}/>}/>
                <NavItem to={'settings'} loc={'/p/settings'} icon={<SettingOutlined/>}
                         text={<IntlMessage id={'settings'}/>}/>
                <NavItem to={'certificates'} loc={'/p/certificates'} icon={<BookOutlined/>}
                         text={<IntlMessage id={'certificates'}/>}/>
            </>
        )
    }

    return (
        <>
            <NavItem to={'user-sign'} loc={'/p/user-sign'} icon={<FileTextOutlined/>}
                     text={<IntlMessage id={'userSignPage'}/>}/>
            <NavItem to={'settings'} loc={'/p/settings'} icon={<SettingOutlined/>}
                     text={<IntlMessage id={'settings'}/>}/>
        </>
    );
};

export default NavMenu;

